import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';

const SubTable = ({ type, driver, team, championship }) => {
    const tableSpan = type === 'driver' ? '9' : '7';

    const [loading, setLoading] = useState(true);
    const [driverId, setDriverId] = useState(driver);
    const [teamId, setTeamId] = useState(team);
    const [championshipId, setChampionshipId] = useState(championship);
    const [driverResults, setDriverResults] = useState([]);
    const [resultsError, setResultsError] = useState({ error: false });

    useEffect(() => {
        const formData = new FormData();

        formData.append('action', 'fetch_database_subtable');
        formData.append('driverId', driverId);
        formData.append('teamId', teamId);
        formData.append('championshipId', championshipId);

        fetch(wp_ajax.db_ajax_url, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        })
            .then(res => res.json())
            .then(response => {
                setLoading(false);

                if ('error' in response.data) {
                    setResultsError({ error: response.error });
                } else {
                    setDriverResults(response.data.driver_results);
                }
            });
    }, [driverId, teamId, championshipId]);

    const driverResultRows = () => {
        if (loading) {
            return (
                <tr>
                    <td colSpan={tableSpan}>{<Loader />}</td>
                </tr>
            );
        }

        return driverResults.map((result, index) => {
            return (
                <tr key={index}>
                    <td className="u-hidden-tablet">
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {result.race_round}
                        </p>                        
                    </td>
                    <td>
                        <p className="database-table__title">
                            <a href={result.race_url}>{result.race_name}</a>
                        </p>
                    </td>
                    <td className="u-hidden-tablet">
                        <p className="database-table__title">
                            <a href={result.circuit_url}>{result.circuit_name}</a>
                        </p>
                    </td>
                    <td className="u-hidden-tablet">
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {result.driver_number}
                        </p>
                        {result.driver_number_2 !== '' && result.driver_number_2 !== result.driver_number && (
                            <p className="database-table__subtitle database-table__subtitle--black proxima">
                                {result.driver_number_2}
                            </p>
                        )}
                    </td>
                    <td>
                        <p className="database-table__title">
                            <a href={result.driver_team_url}>
                                {result.driver_team_entrant.length > 0
                                    ? result.driver_team_entrant
                                    : result.driver_team_name}
                            </a>
                        </p>
                    </td>
                    <td className="u-hidden-mobile">
                        <p className="database-table__title database-table__title--regular">
                            {result.vehicle}
                        </p>
                    </td>
                    <td className="u-hidden-mobile">
                        <p className="database-table__subtitle database-table__subtitle--black proxima">
                            {result.driver_grid_position}
                        </p>
                        {result.driver_grid_position_2 !== '' && result.driver_grid_position_2 !== result.driver_grid_position && (
                            <p className="database-table__subtitle database-table__subtitle--black proxima">
                                {result.driver_grid_position_2}
                            </p>
                        )}
                    </td>
                    <td>
                        <p
                            className="database-table__subtitle database-table__subtitle--black proxima"
                            dangerouslySetInnerHTML={{ __html: result.driver_race_result_position }}></p>
                        {result.driver_race_result_position_2 !== '' && result.driver_race_result_position_2 !== result.driver_race_result_position && (
                            <p
                                className="database-table__subtitle database-table__subtitle--black proxima"
                                dangerouslySetInnerHTML={{ __html: result.driver_race_result_position_2 }}></p>
                        )}
                    </td>
                </tr>
            );
        });
    };

    return (
        <td colSpan={tableSpan}>
            <table className="database-table">
                <thead>
                    <tr>
                        <th className="proxima u-hidden-tablet">Round</th>
                        <th className="proxima">Race Name</th>
                        <th className="proxima u-hidden-tablet">Circuit</th>
                        <th className="proxima u-hidden-tablet">No.</th>
                        <th className="proxima">Team</th>
                        <th className="proxima u-hidden-mobile">Vehicle</th>
                        <th className="proxima u-hidden-mobile">Grid</th>
                        <th className="proxima">Position</th>
                    </tr>
                </thead>
                <tbody>
                    {resultsError.error ? (
                        <tr>
                            <td colSpan={tableSpan}>{resultsError}</td>
                        </tr>
                    ) : (
                        driverResultRows()
                    )}
                </tbody>
            </table>
        </td>
    );
};

export default SubTable;
